module.exports = __webpack_public_path__ + "static/media/frequency_converter.5a0b9011.png";